import { notify } from '../../shared';

import { wipeContact, startCampaignForContact } from '../../api';
import { useConfirm, useRequest } from '../../hooks';
import type { FormType } from './useContacts';

export const useContactActions = (onRefresh: () => void) => {
  const { element: startElement, open: handleOpenStart } = useConfirm();
  const [handleStartCampaign, starting] = useRequest(
    (_signal, item: FormType) =>
      startCampaignForContact({
        campaign_strategy: 'default',
        contact_id: item.id,
        user_email: item.email,
      }),
    {
      deps: [],
      onSuccess: data => {
        notify.success(data?.message || 'Campaign Started');
        onRefresh();
      },
      onError: () => {
        notify.error('Failed to start Campaign');
      },
    }
  );
  const { element: wipeElement, open: handleOpenWipe } = useConfirm();
  const [handleWipeContact, wiping] = useRequest(
    (_signal, item: FormType) => wipeContact(item.id),
    {
      deps: [],
      onSuccess: data => {
        notify.success(data?.message || 'Contact data was cleaned');
        onRefresh();
      },
      onError: () => {
        notify.error('Failed to crean Contact data');
      },
    }
  );

  return {
    progress: starting || wiping,

    startElement,
    openStart: (item: FormType) => {
      return handleOpenStart({
        text: `Are you sure you want to start a campaign for ${item.email}?`,
        onConfirm: () => handleStartCampaign(item),
      });
    },

    wipeElement,
    openWipe: (item: FormType) => {
      return handleOpenWipe({
        text: `This will delete ALL data (tasks, messages, events, states) for ${item.email} but keep the contact. Are you sure?`,
        onConfirm: () => handleWipeContact(item),
      });
    },
  };
};
